import { GROWERS_ROUTES } from '../../../navigation/types/growersRoutes'
import { UserUploadFlow } from '../../UploadFlow'

export const GrowerUploadFlow = () => <UserUploadFlow navSuccessRoute={GROWERS_ROUTES.DETAIL} />
